module.exports = __webpack_public_path__ + "img/96.b6ed4a75.jpg";